// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"697":"a88c858e","873":"8a2f1a5a"}[chunkId] + ".css";
};